const EDGE_ORDER = ["N", "NE", "SE", "S", "SW", "NW"];
const MIRROR = {
    N: "N", NE: "NW", SE: "SW", S: "S", SW: "SE", NW: "NE",
};
function rotateEdge(edge, steps) {
    return EDGE_ORDER[(EDGE_ORDER.indexOf(edge) + ((steps % 6) + 6) % 6) % 6];
}
function normalizeEdgeKey(edges) {
    return [...edges]
        .sort((a, b) => EDGE_ORDER.indexOf(a) - EDGE_ORDER.indexOf(b))
        .join(",");
}
const ROAD_TILE_CATALOG = {
    "Hex - Dirt Path 1 N.png": ["N"],
    "Hex - Dirt Path 1 NE.png": ["NE"],
    "Hex - Dirt Path 1 S.png": ["S"],
    "Hex - Dirt Path 1 SE.png": ["SE"],
    "Hex - Dirt Path 2 N.png": ["N", "S"],
    "Hex - Dirt Path 2 NE.png": ["NE", "SW"],
    "Hex - Dirt Path 9 N.png": ["N", "S"],
    "Hex - Dirt Path 9 SE.png": ["SE", "NW"],
    "Hex - Dirt Path 4 N.png": ["N", "SW"],
    "Hex - Dirt Path 4 NE.png": ["NE", "NW"],
    "Hex - Dirt Path 4 S.png": ["S", "NW"],
    "Hex - Dirt Path 4 SE.png": ["SE", "SW"],
    "Hex - Dirt Path 5 E.png": ["NE", "SE"],
    "Hex - Dirt Path 5 NE.png": ["N", "NE"],
    "Hex - Dirt Path 5 SE.png": ["SE", "S"],
    "Hex - Dirt Path 8 W.png": ["SW", "NW"],
    "Hex - Dirt Path 8 NW.png": ["N", "NW"],
    "Hex - Dirt Path 8 SW.png": ["S", "SW"],
    "Hex - Dirt Path 7 N.png": ["N", "SE", "SW"],
    "Hex - Dirt Path 7 SE.png": ["N", "SE", "SW"],
    "Hex - Dirt Path 7 SW.png": ["N", "SE", "SW"],
    "Hex - Dirt Path 7 S.png": ["NE", "S", "NW"],
    "Hex - Dirt Path 7 NW.png": ["NE", "S", "NW"],
    "Hex - Dirt Path 11 N.png": ["N", "SE", "SW"],
    "Hex - Dirt Path 11 SE.png": ["N", "SE", "SW"],
    "Hex - Dirt Path 11 NE.png": ["NE", "S", "NW"],
    "Hex - Dirt Path 11 S.png": ["NE", "S", "NW"],
    "Hex - Dirt Path 13 N.png": ["N", "SE", "S", "SW"],
    "Hex - Dirt Path 13 NE.png": ["NE", "S", "SW", "NW"],
    "Hex - Dirt Path 13 S.png": ["N", "NE", "S", "NW"],
    "Hex - Dirt Path 13 SE.png": ["N", "NE", "SE", "SW"],
    "Hex - Dirt Path 3 N.png": ["N", "S", "SW"],
    "Hex - Dirt Path 3 NE.png": ["NE", "SW", "NW"],
    "Hex - Dirt Path 3 SE.png": ["N", "SE", "NW"],
    "Hex - Dirt Path 14 N.png": ["N", "S", "SW", "NW"],
    "Hex - Dirt Path 12 N.png": ["N", "SE", "S", "NW"],
    "Hex - Dirt Path 12 E.png": ["NE", "SE", "SW", "NW"],
    "Hex - Dirt Path 15.png": ["N", "NE", "S", "SW", "NW"],
    "Hex - Dirt Path 16.png": ["N", "NE", "SE", "S", "SW", "NW"],
    "Hex - Dirt Path 17.png": ["NE", "S", "NW"],
};
const PREFERRED_EXACT_TILE_BY_EDGE_KEY = new Map([
    [normalizeEdgeKey(["NE", "S", "NW"]), "Hex - Dirt Path 17.png"],
]);
const edgeKeyToInstructions = new Map();
for (const [filename, edges] of Object.entries(ROAD_TILE_CATALOG)) {
    const key = normalizeEdgeKey(edges);
    const list = edgeKeyToInstructions.get(key) ?? [];
    list.push({ filename, rotation: 0, mirrored: false });
    edgeKeyToInstructions.set(key, list);
}
for (const [filename, baseEdges] of Object.entries(ROAD_TILE_CATALOG)) {
    for (let steps = 1; steps <= 5; steps++) {
        const rotated = baseEdges.map((e) => rotateEdge(e, steps));
        const key = normalizeEdgeKey(rotated);
        if (!edgeKeyToInstructions.has(key)) {
            edgeKeyToInstructions.set(key, [{ filename, rotation: steps, mirrored: false }]);
        }
    }
}
for (const [filename, baseEdges] of Object.entries(ROAD_TILE_CATALOG)) {
    for (let steps = 0; steps <= 5; steps++) {
        const transformed = baseEdges.map((e) => rotateEdge(MIRROR[e], steps));
        const key = normalizeEdgeKey(transformed);
        if (!edgeKeyToInstructions.has(key)) {
            edgeKeyToInstructions.set(key, [{ filename, rotation: steps, mirrored: true }]);
        }
    }
}
function simpleHash(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) {
        h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}
function pickFromList(list, hexKey) {
    if (list.length === 1)
        return list[0];
    const idx = hexKey ? simpleHash(hexKey) % list.length : 0;
    return list[idx];
}
const tileEdgeSets = [];
for (const [filename, edges] of Object.entries(ROAD_TILE_CATALOG)) {
    tileEdgeSets.push({ filename, edges: new Set(edges), count: edges.length });
}
tileEdgeSets.sort((a, b) => b.count - a.count);
export function getRoadOverlaysForEdges(edges, hexKey) {
    if (edges.length === 0)
        return [];
    console.log(`Road overlay for edges [${edges.join(", ")}] at ${hexKey ?? "?"}`);
    const key = normalizeEdgeKey(edges);
    const instructions = edgeKeyToInstructions.get(key);
    if (instructions && instructions.length > 0) {
        const preferredFilename = PREFERRED_EXACT_TILE_BY_EDGE_KEY.get(key);
        const preferredInstruction = preferredFilename
            ? instructions.find((instruction) => instruction.filename === preferredFilename)
            : undefined;
        const picked = [preferredInstruction ?? pickFromList(instructions, hexKey)];
        console.log(`  → ${picked[0].filename} rot=${picked[0].rotation} mirror=${picked[0].mirrored}`);
        return picked;
    }
    if (edges.length === 6) {
        const yA = edgeKeyToInstructions.get(normalizeEdgeKey(["N", "SE", "SW"]));
        const yB = edgeKeyToInstructions.get(normalizeEdgeKey(["NE", "S", "NW"]));
        if (yA && yB) {
            return [
                pickFromList(yA, hexKey),
                pickFromList(yB, hexKey ? hexKey + "b" : undefined),
            ];
        }
    }
    const needed = new Set(edges);
    const result = [];
    const covered = new Set();
    while (covered.size < needed.size) {
        let bestInstruction = null;
        let bestCount = 0;
        for (const [edgeKey, instrList] of edgeKeyToInstructions.entries()) {
            const tileEdges = edgeKey.split(",");
            let allIn = true;
            let matchCount = 0;
            for (const e of tileEdges) {
                if (!needed.has(e)) {
                    allIn = false;
                    break;
                }
                if (!covered.has(e))
                    matchCount++;
            }
            if (!allIn || matchCount === 0)
                continue;
            if (matchCount > bestCount) {
                bestCount = matchCount;
                bestInstruction = pickFromList(instrList, hexKey ? hexKey + result.length : undefined);
            }
        }
        if (!bestInstruction)
            break;
        result.push(bestInstruction);
        const instrEdges = Object.entries(ROAD_TILE_CATALOG).find(([f]) => f === bestInstruction.filename);
        if (instrEdges) {
            const baseEdges = instrEdges[1];
            let transformed;
            if (bestInstruction.mirrored) {
                transformed = baseEdges.map((e) => rotateEdge(MIRROR[e], bestInstruction.rotation));
            }
            else {
                transformed = baseEdges.map((e) => rotateEdge(e, bestInstruction.rotation));
            }
            for (const e of transformed)
                covered.add(e);
        }
    }
    return result;
}
export function getAllRoadFilenames() {
    return Object.keys(ROAD_TILE_CATALOG);
}
